<template>
  <div id="TianTable">
    <ul class="pro_list">
      <van-row type="flex" justify="center" class="olTit">
        <van-col span="9">商铺</van-col>
        <van-col span="6">{{(new Date()).valueOf()>=1592323200000?'销售额 (`000)':'销售额 (`000)'}}</van-col>
        <van-col span="5">目标(`000)</van-col>
        <van-col span="4">完成率</van-col>
      </van-row>
    </ul>
    <div class="box">
      <van-row type="flex" justify="center" class="OneTie active">
        <van-col span="9">Tmall总和</van-col>
        <van-col span="6">{{salesValue|NumFormat}}</van-col>
        <van-col span="5">{{targetValue|NumFormat}}</van-col>
        <van-col span="4">{{achieving==''?0.0+"%":achieving}}</van-col>
      </van-row>
    </div>
    <div class="box">
      <van-row type="flex" class="OneTie" v-for="(item,i) in tableList" :key="i">
        <van-col span="9">{{item.shopNm}}</van-col>
        <van-col span="6">{{item.salesValue|NumFormat}}</van-col>
        <van-col span="5">{{item.targetValue|NumFormat}}</van-col>
        <van-col span="4">{{item.achieving==''?0.0+'%':item.achieving}}</van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
      isShow: true,
      targetValue: 0,
      salesValue: 0,
      achieving: 0
    };
  },
  methods: {
    getList() {
      this.$addr
        .post("Sales/getTmallShopNmData", { monthType: null })
        .then(res => {
          this.tableList = res.data.data;
        })
        .catch(error => {
          // this.$toast('接受数据失败');
        });
    },
    getTableAll() {
      this.$addr
        .post(`Sales/getTmallSumData?type=1`)
        .then(res => {
          this.targetValue = res.data.data[0].targetValue;
          this.salesValue = res.data.data[0].salesValue;
          this.achieving = res.data.data[0].achieving;
        })
        .catch(error => {
          // this.$toast('接受数据失败');
        });
    }
  },
  created() {
    this.getList();
    this.getTableAll();
  }
};
</script>
<style scoped>
#TianTable {
  overflow: hidden;
}
.pro_list {
  margin: 0 0;
  width: 100%;
  text-align: center;
}
.pro_list .olTit {
  font-size: 12px;
  display: flex;
  height: 21px;
  background: rgba(209, 83, 75, 0.3);
  align-items: center;
  justify-content: space-around;
}
.pro_list ol > li {
  font-family: "PingFangSC-Medium";
  font-size: 10px;
  color: #343434;
}
.pro_list ol>li:first-child{
  margin-left:25px ;
}
.pro_list ol>li:nth-child(2){
  margin-left:20px ;
}
.pro_list ol>li:nth-child(3){
  margin-left:10px ;
}
.pro_list ol>li:last-child{
  margin-left:10px ;
}
.box {
  margin: 0 auto;
  padding: 0 14px;
}
.OneTie {
  text-align: center;
  width: 100%;
  height: 35px;
  background: #ffffff;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  line-height: 35px;
  font-family: "PingFangSC-Regular";
  font-size: 12px;
  color: #000000;
}
.active {
  width: 103%;
  margin-bottom: 4px;
  margin-left: -7px;
  background: #ffffff;
  box-shadow: 5px 5px 5px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: "PingFangSC-Semibold";
  font-size: 12px;
  color: #000000;
  font-weight: bold;

}
.TwoTie {
  margin-bottom: 2px;
  font-family: "PingFangSC-Light";
  font-size: 11px;
  color: #191919;
  width: 100%;
  height: 35px;
  border-bottom: 2px solid rgba(157, 157, 157, 0.4);
  line-height: 35px;
}
</style>


// WEBPACK FOOTER //
// src/components/TianMao/Tian_tableList.vue